<template>
<div class='b-plan-table__add_an_appointment'>
    <div v-if='fristHalfTime'
         class='b-plan-table__add_an_appointment__item'
         @click='currentHalf(fristHalfTime)'>
        <span class='h-mr-3'>
            {{ fristHalfTime }}
        </span>
        <!--<span>-->
        <!--{{ $t('CALENDAR.POPUP.ADD.APPOINTMENT.TITLE') }}-->
        <!--</span>-->
    </div>
    <div v-if='secondHalfTime'
         class='b-plan-table__add_an_appointment__item'
         @click='currentHalf(secondHalfTime)'>
        <span class='h-mr-3'>
            {{ secondHalfTime }}
        </span>
        <!--<span>-->
        <!--{{ $t('CALENDAR.POPUP.ADD.APPOINTMENT.TITLE') }}-->
        <!--</span>-->
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-facing-decorator';

import { UserType } from '@/types/User';

@Component({
    emits: ['openAddAppointmentPopup'],
})
export default class AddAnAppointment extends Vue {
    @Prop({ type: String, default: null }) readonly fristHalfTime!: string;
    @Prop({ type: String, default: null }) readonly secondHalfTime!: string;
    @Prop({ type: String, default: null }) readonly choosedDay!: string;
    @Prop({ type: Object, default: null }) readonly userData!: UserType;

    currentHalf(half: string) {
        this.$emit('openAddAppointmentPopup', this.userData, half, new Date(this.choosedDay));
    }
}
</script>
<style lang='sass'>
.b-plan-table__add_an_appointment
    width: 100%
    max-width: 100%
    color: #27DBBD
    background-color: #E9FBF8
    border-radius: 5px
    font-size: 9px
    line-height: 14px
    padding: 5px 3px
    position: absolute
    left: 0
    top: 5px
    height: 100%
    z-index: 2

    &__item
        width: 100%
        display: flex
        opacity: 0
        height: 50%
        border: 1px dashed
        align-items: center
        justify-content: center
        cursor: pointer

        &:hover
            opacity: 1

    &--full-day
        .b-plan-table__add_an_appointment__item
            height: 100%
            border: none
            flex-direction: column
</style>
